import { enumScannerStatus } from '@rematter/frontend-lib-api-client';

import type { ScannerDetailRecord } from '../types/sidecar';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export const scannerDetailQueryAtom = createQueryAtomFactory(
  'settings.scannerDetail',
  (params: { ids: string[] }) => ({
    scanners: {
      __args: {
        filter: {
          ids: params.ids,
        },
        pagination: {
          limit: 1,
          offset: 0,
        },
      },
      entries: {
        id: true,
        sidecarId: true,
        uniqueId: true,
        driverType: true,
        name: true,
        manufacturer: true,
        model: true,
        firmwareVersion: true,
        status: true,
        online: true,
        lastSeenAt: true,
        sidecar: {
          id: true,
          name: true,
          peerId: true,
          multiaddrs: true,
          status: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: (data): ScannerDetailRecord | null => {
      const entry = data?.scanners?.entries?.[0];
      if (!entry) {
        return null;
      }

      return {
        id: entry.id,
        sidecarId: entry.sidecarId,
        uniqueId: entry.uniqueId,
        driverType: entry.driverType,
        name: entry.name,
        manufacturer: entry.manufacturer ?? null,
        model: entry.model ?? null,
        firmwareVersion: entry.firmwareVersion ?? null,
        status: entry.status ?? enumScannerStatus.Discovered,
        online: entry.online ?? false,
        lastSeenAt: entry.lastSeenAt
          ? parseZonedDateTime(entry.lastSeenAt)
          : null,
        sidecar: entry.sidecar
          ? {
              id: entry.sidecar.id,
              name: entry.sidecar.name,
            }
          : null,
        sidecarDetail: entry.sidecar
          ? {
              id: entry.sidecar.id,
              name: entry.sidecar.name,
              peerId: entry.sidecar.peerId ?? null,
              multiaddrs: (entry.sidecar.multiaddrs as string[]) ?? [],
              status: entry.sidecar.status,
            }
          : null,
        timestamps: {
          createdAt: parseZonedDateTime(entry.timestamps.createdAt),
          updatedAt: parseZonedDateTime(entry.timestamps.updatedAt),
        },
      };
    },
  },
);
